import { render } from "./HandHoldingDollarIcon.vue?vue&type=template&id=45b99576"
import script from "./HandHoldingDollarIcon.vue?vue&type=script&lang=js"
export * from "./HandHoldingDollarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__